import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';

export const ADD_IS_POSTPAID: string = "ADD_IS_POSTPAID";
export const ADD_BASE_CURRENCY_VALUE: string = "ADD_BASE_CURRENCY_VALUE";
export const ADD_MAX_POSTPAID_LIMIT: string = "ADD_MAX_POSTPAID_LIMIT";
export const ADD_BASE_CURRENCY_SYMBOL: string = "ADD_BASE_CURRENCY_SYMBOL";
export const ADD_POSTPAID_USAGE: string = "ADD_POSTPAID_USAGE";
export const ADD_FULL_BALANCE: string = "ADD_FULL_BALANCE";
export const IS_LOADING: string = "IS_LOADING";


export function addIsPostpaid(isPostpaid: number): IAddIsPostpaidActionType {
    return { type: ADD_IS_POSTPAID, isPostpaid: isPostpaid };
}
export function isLoading(loading: boolean) {
    return { type: IS_LOADING, loading: loading };
}
export function addBaseCurrencyVal(baseCurrencyVal: number): IAddBaseCurrencyValActionType {
    return { type: ADD_BASE_CURRENCY_VALUE, baseCurrencyVal: baseCurrencyVal };
}
export function addMaxPostpaidLimit(maxPostpaidLimit: number): IAddMaxPostpaidLimitActionType {
    return { type: ADD_MAX_POSTPAID_LIMIT, maxPostpaidLimit: maxPostpaidLimit };
}
export function addBaseCurrencySymbol(baseCurrencySymbol: string): IAddBaseCurrencySymbolActionType {
    return { type: ADD_BASE_CURRENCY_SYMBOL, baseCurrencySymbol: baseCurrencySymbol };
}
export function addPostpaidUsage(postPaidUsage: number): IAddPostPaidUsageActionType {
    return { type: ADD_POSTPAID_USAGE, postPaidUsage: postPaidUsage };
}
export function addFullBalanceObject(fullBalanceObject: any): IAddFullBalanceActionType {
    return { type: ADD_FULL_BALANCE, fullBalanceObject: fullBalanceObject };
}
export const callBalanceAPI = () => {

    return (dispatch: Dispatch<any>) => {
        dispatch(isLoading(true));
        networkCall('get', '/balance', apiBaseUrl.baseUrl)
            .then((response: any) => {
                dispatch(isLoading(false));
                if (response.data && response.data.length) {
                    const resp = response.data;
                    dispatch(addFullBalanceObject(resp[0]));
                    dispatch(addIsPostpaid(resp[0].is_postpaid));
                    dispatch(
                        addBaseCurrencyVal(
                            parseFloat(resp[0].value_in_base_currency)
                        )
                    );
                    dispatch(
                        addMaxPostpaidLimit(
                            parseFloat(resp[0].max_postpaid_limit)
                        )
                    );
                    dispatch(
                        addBaseCurrencySymbol(resp[0].base_currency_symbol)
                    );
                    dispatch(
                        addPostpaidUsage(resp[0].usage)
                    )
                } else {
                    console.log('Balance is empty');
                }
            })
            .catch(function (error: any) {
                dispatch(isLoading(false));
                console.log(JSON.stringify(error));
            });
    }
}

interface IAddIsPostpaidActionType {
    type: string,
    isPostpaid: number
}

interface IAddBaseCurrencyValActionType {
    type: string,
    baseCurrencyVal: number
}

interface IAddMaxPostpaidLimitActionType {
    type: string,
    maxPostpaidLimit: number
}

interface IAddBaseCurrencySymbolActionType {
    type: string,
    baseCurrencySymbol: string
}

interface IAddPostPaidUsageActionType {
    type: string,
    postPaidUsage: number
}

interface IAddFullBalanceActionType {
    type: string,
    fullBalanceObject: any
}